import { render } from "./ConfidenceThresholdFilter.vue?vue&type=template&id=5b719348&scoped=true"
import script from "./ConfidenceThresholdFilter.vue?vue&type=script&lang=js"
export * from "./ConfidenceThresholdFilter.vue?vue&type=script&lang=js"

import "./ConfidenceThresholdFilter.vue?vue&type=style&index=0&id=5b719348&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b719348"]])

export default __exports__